import Image from 'next/image';
import Form from '../ui/Form';
import { useRef, useState } from 'react';
import { useGSAP } from '@gsap/react';
import gsap from 'gsap';
import { useRouter } from 'next/router';



const CTA = ({title, image, formInfo, formResponse, bottomTitle, isBottomSectionNeed = false, bottomText1, bottomText2}) => {


    const polygonBlock = useRef(null)
    const sectionRef = useRef(null)
    const titleRef = useRef(null)

    const bottomTitleRef = useRef(null)
    const bottoTextRef = useRef(null)
    const bottomSectionRef = useRef(null)
    const containerRef = useRef(null)
    const imageParallax = useRef(null)

    const router = useRouter()
    const { locale } = router

    const [isAllTextShown, setIsAllTextShown] = useState(false)

    useGSAP(()=> {

        gsap.fromTo(polygonBlock.current, {
          clipPath: "polygon(50% 0%,50% 0%,50% 50%,50% 100%,50% 100%,50% 50%)"
    }, {
        clipPath: "polygon(50% 0%, 100% 0%, 50% 50%, 50% 100%, 0% 100%, 50% 50%)",
            ease: "none",
            scrollTrigger: {
                trigger: sectionRef.current,
                start: "top 50%", 
                end: "25% 50%",  
                scrub: 1, 
                // markers: true
            },
        })

            const mm = gsap.matchMedia();
        
            mm.add("(min-width: 1280px)", () => {

                     gsap.fromTo(containerRef.current, {
                        y: '13rem'
                    },
                        {
                        y: 0,
                        ease: "none",
                        scrollTrigger: {
                        trigger: sectionRef.current,
                        start: "top bottom", 
                        end: "top 60%",  
                        scrub: 0.1,  
                        },
                    });


                gsap.fromTo(titleRef.current, {
                  opacity: 0
                  },
                   {
                  opacity: 1,
                  duration: 1,
                  scrollTrigger: {
                    trigger: sectionRef.current,
                    start: "top 80%",
                  },
                });

                
                        gsap.fromTo(imageParallax.current, {
                          y: '5rem'
                        },
                           {
                          y: '-5rem',
                          ease: "none",
                          scrollTrigger: {
                            trigger: sectionRef.current,
                            start: "top bottom", 
                            end: "top top",  
                            scrub: 0,  
                          },
                        });


                if (bottomTitleRef.current) {
                    gsap.fromTo(bottomTitleRef.current, {opacity: 0, x: '-5rem'}, {
                        opacity: 1,
                        x: 0,


                        duration: 1,
                        scrollTrigger: {
                            trigger: bottomSectionRef.current,
                            start: "top 80%",
                        },
                    });
                }

                if (bottoTextRef.current) {
                    gsap.fromTo(bottoTextRef.current, {opacity: 0}, {
                        opacity: 1,

                        duration: 1,
                        scrollTrigger: {
                            trigger: bottomSectionRef.current,
                            start: "top 80%",
                        },
                    });
                }
            
            })
  }, {scope: sectionRef});

    return (
        <section ref={sectionRef} className="pt-[4rem] container-max pb-[8rem] md:pt-[6rem] lg:pt-[8rem] xl:pt-[10rem] md:pb-[8rem] lg:pb-[14rem] xl:pb-[14rem]">
            {/* <ScrollToTop isActive={isScrollToTopActive}></ScrollToTop> */}

            <div ref={containerRef} className='w-full'>

                <div className="text-center container-padding">
                    <h2 ref={titleRef} className="[&>.selected]:italic [&>.selected]:text-dusty-blue-light heading-3 mb-[2.8rem] md:mb-[4rem] xl:mb-[6rem]" dangerouslySetInnerHTML={{__html: title}}/>
                </div>

                <div className={'w-full relative pointer-events-none h-[28rem] flex items-center justify-center overflow-hidden md:h-[24.6rem] xl:h-[32.8rem] '}>
                    <div ref={imageParallax} className='relative w-full h-[200%]'>
                        <Image
                            src="/images/temporal/cta.jpg"
                            alt="Минималистичный интерьер"
                            fill={true}
                            sizes={'100vw'}
                            quality={80}
                            className={'w-auto object-cover object-[center_70%]'}
                        />
                    </div>

                            <div ref={polygonBlock} className='bg-sky-blue right-[46.0%] scale-[1.005] bottom-0 translate-x-1/2 absolute z-10 h-[150%] aspect-[1.5] '></div>

                        {/* <div ref={polygonBlock} className='scale-[1.01] block bg-sky-blue right-[40%] translate-x-1/2 absolute z-10 h-full aspect-[2/1] '></div> */}
                </div>

                <div className='container-padding mb-[8rem]'>
                    <div className='container-grid'>
                        <Form formInfo={formInfo} formResponse={formResponse} trianglesColorClass={'bg-sky-blue'}/>
                    </div>
                    <div className='container-grid'></div>
                </div>

                {isBottomSectionNeed ? <div ref={bottomSectionRef} className='container-padding container-grid lg:pt-[6rem] flex-col text-center'>
                    <h2  ref={bottomTitleRef} className='[&>.selected]:italic [&>.selected]:text-dusty-blue-light heading-3 mb-[1.2rem] lg:text-end md:mb-[2rem] col-span-5' dangerouslySetInnerHTML={{__html: bottomTitle}}/>
                    <div ref={bottoTextRef} className='lg:mt-[0.8rem] xl:mt-[1.4rem] w-full flex flex-col col-span-5 lg:col-start-7 items-center lg:items-start'>
                        <div className='md:max-w-[46.9rem] lg:max-w-[48.8rem] xl:max-w-[52.2rem] px-[1.5rem] lg:px-0 lg:text-start flex flex-col gap-[1.6rem]'>
                            <p className='text-1 ' dangerouslySetInnerHTML={{__html: bottomText1}}/>
                            {isAllTextShown ? <p className='text-1' dangerouslySetInnerHTML={{__html: bottomText2}}/> : null}

                        </div>
                        {isAllTextShown ? null : 
                        <button onClick={()=>{setIsAllTextShown(true)}} className='mt-[3.2rem] md:mt-[4rem] col-span-5 cursor-pointer text-link'>{locale === 'ru' ? 'показать больше' : 'show more'}</button>}
                    </div>

                    
                </div> : <div ref={bottomSectionRef} className='container-padding container-grid lg:pt-[6rem] flex-col text-center'></div>}

            </div>
        </section>
    );
};

export default CTA;